import { useEffect, useState } from 'react';
import { Button, Sheet } from '@/components';
import { useSession } from '@/app/session-context';
import { completedLessonCount } from '@/data/progress';
import { anythingConfigured } from '@/lib/analytics';
import { decideConsent, readConsent, shouldAskConsent } from '@/lib/consent';
import { t } from '@/i18n';

/**
 * The one-time question (plan docs 01 and 17), asked after the first finished
 * lesson and never on first launch. Closing the sheet without choosing counts
 * as no: silence is not consent, and the question is not asked again — the
 * switches are in Settings for anyone who changes their mind.
 */
export function ConsentSheet() {
  const { profile } = useSession();
  const minor = profile.flags.minor;
  const [open, setOpen] = useState(false);

  useEffect(() => {
    let cancelled = false;
    void completedLessonCount().then((lessonsCompleted) => {
      if (cancelled) return;
      setOpen(
        shouldAskConsent({
          state: readConsent(),
          minor,
          lessonsCompleted,
          configured: anythingConfigured(),
        }),
      );
    });
    return () => {
      cancelled = true;
    };
  }, [minor]);

  const decide = (granted: boolean): void => {
    decideConsent(granted);
    setOpen(false);
  };

  return (
    <Sheet open={open} onClose={() => decide(false)} title={t('privacy.consentTitle')}>
      <p className="mb-4 text-sm text-text-2">{t('privacy.consentBody')}</p>
      <div className="flex flex-col gap-2">
        <Button block onClick={() => decide(true)}>
          {t('privacy.consentYes')}
        </Button>
        <Button block variant="neutral" onClick={() => decide(false)}>
          {t('privacy.consentNo')}
        </Button>
      </div>
    </Sheet>
  );
}
